<span class="inline-flex items-center">
    <ng-content></ng-content>

  @if (isHeading && useForSorting) {
    <svg
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      class="w-5 h-5 fill-slate-500 group-aria-[sort=ascending]:rotate-0 group-aria-[sort=descending]:rotate-180"
    >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 5a.75.75 0 01.75.75v6.638l1.96-2.158a.75.75 0 111.08 1.04l-3.25 3.5a.75.75 0 01-1.08 0l-3.25-3.5a.75.75 0 111.08-1.04l1.96 2.158V5.75A.75.75 0 0110 5z"
        />
      </svg>
  }
  </span>
